<template>
    <ui-modal small>
        <template #header>
            <h3 class="mb-0 text-center" v-text="isEditMode ? 'Zmiana karty' : 'Dodawanie karty'" />
        </template>

        <h6 class="font-weight-normal">
            {{ isEditMode ? 'Zmiana' : 'Dodanie' }} karty spowoduje przekierowanie na płatność
            autoryzacyjną{{ isEditMode ? '' : ', a sposób płatności zmieni się na automatyczne obciążenie karty' }}.
        </h6>
        <h6 class="font-weight-normal">
            Podana przez Ciebie karta ulegnie weryfikacji poprzez pobranie
            z konta opłaty w wysokości 1 zł. Po zweryfikowaniu ważności
            karty i dostępności środków na koncie opłata zostanie zwrócona.
        </h6>

        <template #footer>
            <the-btn
                text="Zamknij"
                class="btn-outline-custom"
                :disabled="isLoader"
                @click="!isLoader && $emit('close-modal')"
            />
            <the-btn
                :text="isEditMode ? 'Zmień kartę' : 'Dodaj kartę'"
                :loading-status="isLoader ? 'loading' : 'idle'"
                :icon="isLoader ? 'Spinner' : ''"
                class="btn-secondary"
                @click="addCard"
            />
        </template>
    </ui-modal>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    data: () => ({
        isLoader: false
    }),

    computed: {
        isEditMode() {
            return this.$store.getters.modalState?.args?.mode === 'edit'
        }
    },

    methods: {
        ...mapActions('payment', ['updatePaymentInfo']),

        addCard() {
            this.isLoader = true
            this.updatePaymentInfo({
                payment_type: 'automatic'
            }).finally(() => {
                setTimeout(() => {
                    this.isLoader = false
                }, 3000)
            })
        }
    }
}
</script>